<template>
    <div>
        <vx-label size="lg">Select a Campaign</vx-label>
        <div class="vx-flex vx-gap-2">
            <select-campaign size="lg"
                v-model="data.campaign_id"
                :flowId="props.flowId"
                :error="displayFirstError(validate.campaign_id)"></select-campaign>
            <campaign-details-popover v-if="data.campaign_id" :hover="false" :placement="is2Xl ? 'top' : 'left'" :modelValue="{ id: data.campaign_id }">
                <vx-button
                    type="button"
                    size="lg"
                    color="muted-light"
                    >
                        <font-awesome-icon :icon="faInfoCircle"></font-awesome-icon>
                </vx-button>
            </campaign-details-popover>
        </div>

        <use-event-contact-action-data class="vx-mt-4" v-model="data"></use-event-contact-action-data>
    </div>
</template>

<script setup>
import SelectCampaign from '~/components/general/SelectCampaign.vue';
import UseEventContactActionData from './UseEventContactActionData.vue';
import { VxLabel, VxButton } from '@voxie/frontend-components';
import { displayFirstError } from '~/utils/validation';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CampaignDetailsPopover from '~/components/campaigns/campaign-card/CampaignDetailsPopover.vue';
import { useMediaQuery } from '@vueuse/core';

const props = defineProps({
    flowId: String
});

const data = defineModel();
const is2Xl = useMediaQuery('(min-width: 1536px)');

const validate = useVuelidate({
    campaign_id: {
        required: helpers.withMessage('Campaign is required', required)
    }
}, data)
</script>
